import type { IntegrityStatus } from "~utils/moduleIntegrity";

import type { ModuleProps } from "./Module";

export default function integrityCheck(
    props: Omit<ModuleProps, "duplicateOf">
): IntegrityStatus {
    if (!props.id) {
        return ["Missing module id"];
    }

    return [];
}
